import { CONSUMER_APP_SOURCE, ConsumerEventData, ConsumerMessageEventData } from '@upflowy/types';

interface IframeChannel {
  postMessage: (msg: ConsumerMessageEventData, origin: string) => void;
}

interface Scope {
  origin: string;
  containerId: string;
}

export default class DataStream {
  private channel: IframeChannel;

  private scope: Scope;

  constructor(channel: IframeChannel, scope: Scope) {
    this.channel = channel;
    this.scope = scope;
  }

  post(message: ConsumerEventData) {
    this.channel.postMessage(
      {
        ...message,
        source: CONSUMER_APP_SOURCE,
        containerId: this.scope.containerId,
      },
      this.scope.origin,
    );
  }
}
